import { render, staticRenderFns } from "./FoodTodoProductGroupCard.vue?vue&type=template&id=5b3ecfa4&scoped=true&lang=pug&"
import script from "./FoodTodoProductGroupCard.vue?vue&type=script&lang=ts&"
export * from "./FoodTodoProductGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./FoodTodoProductGroupCard.vue?vue&type=style&index=0&id=5b3ecfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ecfa4",
  null
  
)

export default component.exports